
export function showInParagraphs(text) {
    return text && text.split("\n\n").map(
      (paragraph, index) => (
        <p key={index}>{paragraph}</p>
      )
    );
  }